<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      keep-source
      row-key
      ref="table"
      size="small"
      show-footer
      class="sample-material-table"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            v-if="!disabled"
            size="sm"
            class="mr-2"
            variant="outline-success"
            :disabled="disabled"
            @click="openSampleMaterialDialog({ type: 'add' })"
            >{{ $l('form_label_add_fabric') || '新增面料' }}
          </b-button>
        </slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageCode
              ? $osscdn(row.defaultImageCode)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:materialNoInfo="{ row }">
        <span>{{ row.materialNo }} </span>
        <br />
        <span
          >{{ row.mainMaterialCategoryName }}/
          {{ row.detailMaterialCategoryName }}</span
        >
      </template>
      <template v-slot:materialNameInfo="{ row }">
        <span>{{ row.materialName }} </span>
        <br />
        <span>{{ row.materialNameEn }}</span>
        <br />
      </template>
      <template v-slot:displayNameInfo="{ row }">
        <span>{{ row.displayName }} </span>
        <br />
        <span>{{ row.displayNameEn }}</span>
      </template>
      <template v-slot:usageQtyInfo="{ row }">
        <span>{{ row.usageQty }} {{ row.qtyUnit }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openSampleMaterialDialog({ type: 'edit', form: row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}"> </template>
    </vxe-grid>

    <!-- 样品面料dialog -->
    <SampleMaterialDialog
      :disabled="sampleMaterialDialogOptions.disabled"
      :visible.sync="sampleMaterialDialogOptions.visible"
      :title="sampleMaterialDialogOptions.title"
      :form.sync="sampleMaterialDialogOptions.form"
      @reload="loadData()"
      @addData="addData"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import SampleMaterialDialog from './components/detail/dialog.vue'
import tableColumns from './table-columns'
export default {
  components: { SampleMaterialDialog },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    materialList: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      tableHeight: 300,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableData: [],
      tableColumns: tableColumns(this, this.disabled),
      sampleMaterialDialogOptions: {
        disabled: false,
        visible: false,
        title: '',
        form: {},
      },
    }
  },
  watch: {
    materialList: {
      handler() {
        this.tableData = JSON.parse(JSON.stringify(this.materialList))
      },
      immediate: true,
    },
  },
  computed: {},

  methods: {
    del(row) {
      this.$confirm('您确定要删除该数据吗?').then((type) => {
        if (type === 'confirm') {
          let index = this.$refs.table.getRowIndex(row)
          this.tableData.splice(index, 1)
        }
      })
    },

    openSampleMaterialDialog({ type, form = {} }) {
      const types = {
        add: this.$l('INDEX.dialog_title_fabric_information') || '添加面料信息',
        edit:
          this.$l('INDEX.dialog_title_edit_fabric_formation') || '编辑面料信息',
      }
      this.sampleMaterialDialogOptions = {
        visible: true,
        disabled: type === 'edit',
        title: types[type],
        form,
      }
    },
    addData(res) {
      if (!res) return
      for (let index = 0; index < this.tableData.length; index++) {
        if (res.uuid === this.tableData[index].uuid) {
          this.$set(this.tableData, index, res)
          return
        }
      }
      this.tableData.push(res)
    },

    getTableData() {
      if (this.tableData.length === 0) {
        this.$message.error(this.$l('please_Add_fabric') || '请添加面料')
        return
      }
      return this.tableData
    },
  },
}
</script>
<style lang="scss" scoped></style>
